module.exports = __webpack_public_path__ + "static/media/sponsors.1050a691.png";